import {Component, Input, Output, OnInit, EventEmitter} from '@angular/core';
import {EPSEvent, formatControlTypeCounts} from "../../classes/event";
import {EventManagementService} from "../../services/event-management.service";
import {SharedService} from "../../services/shared.service";
import {RefDataService} from "../../services/ref-data.service";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {Product} from "../../classes/product";

@Component({
  standalone: false,
  selector: 'tr[app-event-row]',
  templateUrl: './event-row.component.pug',
  styleUrls: ['./event-row.component.scss']
})
export class EventRowComponent implements OnInit {

  @Input() event: EPSEvent;
  @Input() aggregateView: boolean;
  @Input() showEstimatedPerformance: boolean;
  @Input() selectingEvents:boolean;
  @Input() selectable:boolean;
  @Input() nodeTypes;
  @Output() selectEvent : EventEmitter<any> = new EventEmitter();

  comProductObj;
  private ngUnsubscribe: Subject<any> = new Subject();

  controlTypesMap: {[key: string]: string} = {};
  controlTypesLoaded = false;

  constructor(
    private eventManagementService: EventManagementService,
    private sharedService: SharedService,
    private refDataService: RefDataService
  ) { }

  ngOnInit() {
    this.comProductObj = this.event.product;

    this.refDataService.getControlTypes().pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe(controlTypes => {
      if (controlTypes) {
        controlTypes.forEach(ct => {
          this.controlTypesMap[ct.code] = ct.short_display_labels?.en_US || ct.display_label;
        });
        this.controlTypesLoaded = true;
      }
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  clickSelect(): void {
    //Calls the function we pass in from the Event Detail Service
    this.selectEvent.emit();
  }

  fixedDecimals(value, numDecimals = 3) {
    if(typeof(value) === 'number')
      return value.toFixed(numDecimals);
    else
      return null;
  }

  getEstimatedPerformance(): string {
    if (this.event.fit_data_ind !== false) return '';

    const value = this.event.event_progress_status === 'AFTER'
      ? this.event.average_performance_percentage_est
      : this.event.last_current_performance_percentage_est;
    const fixed = this.fixedDecimals(value, 1);
    return fixed != null ? fixed + ' %' : '';
  }

  getControlTypeCounts(): {type: string, count: number}[] {
    if (!this.controlTypesLoaded || !this.event) return [];

    return formatControlTypeCounts((this.event as any).event_node_control_type_counts, this.controlTypesMap);
  }
}
